
export default {
  name: "CardBusca",
};
